/** Tiny DOM helper – the UI is plain DOM/CSS (no UI framework, no extra bundle weight). */
export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string,
  parent?: HTMLElement,
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);
  if (className) element.className = className;
  if (text !== undefined) element.textContent = text;
  parent?.appendChild(element);
  return element;
}

export function formatNumber(value: number): string {
  return Math.floor(value).toLocaleString('de-DE');
}
